"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevateYourImage() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="224189" id="who-we-are" className="text-foreground relative min-h-screen flex flex-col items-center justify-center py-24 px-4 overflow-hidden light bg-background">
            {}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-multiply" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0L30 60M0 30L60 30' fill='none' stroke='%230D3B66' stroke-width='0.5'/%3E%3C/svg%3E")`,
      backgroundPosition: 'bottom right',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '400px 400px'
    }} aria-hidden="true" />

            <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center">
                <h1 ref={titleRef} className={`font-default text-5xl md:text-7xl font-bold tracking-tight text-center text-primary mb-12 md:mb-20 transition-all duration-1000 ease-out ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                    Negotiators & Cost Reduction Experts, <span className="font-light italic">Accelerated by AI</span>
                </h1>

                <div ref={contentRef} className={`border-2 border-muted p-8 md:p-16 lg:p-20 max-w-4xl text-center flex flex-col items-center gap-10 md:gap-14 transition-all duration-1000 delay-300 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                    <p className="font-default text-xl leading-relaxed text-muted-foreground !not-italic md:text-2xl lg:text-3xl md:leading-snug">Procurement consultants specialized in <span className="text-foreground font-semibold" data-ast-id="f:/src/pages/Home/sections/ElevateYourImage.tsx|sig:fqd0ox" data-ast-start="2153" data-ast-end="2343" contenteditable="false" style={{}}>Logistics, Packaging</span>&nbsp;and <span className="text-foreground font-semibold" data-ast-id="f:/src/pages/Home/sections/ElevateYourImage.tsx|sig:fqd0ow" data-ast-start="2353" data-ast-end="2541">Strategic Sourcing,</span> designed to drive innovation and increase your profit margins.<br /></p>

                    <p className="italic text-muted-foreground text-lg md:text-xl">Your Procurement Outsourcing Hub: reducing costs and <br />improving supply chain performance as an extension of your team.</p>

                    <Button asChild size="lg" className="bg-accent hover:bg-accent/90 text-accent-foreground px-10 py-6 text-lg font-semibold tracking-wide mt-4 md:mt-8 rounded-lg shadow-md transition-transform hover:scale-105">
                        <Link to="#lets-talk">
                            Book Your Free Cost-Reduction Call
                        </Link>
                    </Button>
                </div>
            </div>
        </section>;
}